import type { ClientTool } from '../hooks/useClientTools';
/**
 * Client-side Workflow Execution status monitoring tool.
 *
 * This tool simply echoes the given execution id, so then the UI can detect this
 * tool call in a chat and render a corresponding UI component that will poll that
 * execution's status out-of-band while allowing the chat to continue without polluting
 * the conversation's context with the (possibly lengthy) poll results.
 */
export const monitorExecutionStatus: ClientTool = {
  name: 'monitor_execution_status',
  description: `Monitors the status of a given execution. The execution is specified by a given execution id. This tool assumes the execution has already started, so there is no need to create the execution. This tool is responsible for retrieving the execution status and displaying it as a visualization for the user's convenience.`,
  parameters: {
    type: 'object',
    properties: {
      id: {
        type: 'string',
        description: 'The id of the workflow execution whose status is to be displayed.',
      },
    },
    required: ['id'],
  },
  handler: async (args: any) => {
    if (!args.id) {
      return { error: { message: 'No execution id was specified.' } };
    }
    return {
      result: {
        success: true,
        message: 'The execution is now being monitored.',
      },
    };
  },
};
